module.exports = __webpack_public_path__ + "images/19132-EXT1-Cam03-e53e0e004de1d044d3f09466c501523c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_1/19132-EXT1-Cam03.jpg
// module id = 744
// module chunks = 0